export const isObject = (item: any) => {
  return (item && typeof item === 'object' && !Array.isArray(item));
}

export const deepMerge = <T>(target: T, ...sources: any[]): T => {
  if (!sources.length) return target;
  const source = sources.shift();

  if (isObject(target) && isObject(source)) {
    for (const key in source) {
      if (isObject(source[key])) {
        if (!target[key]) Object.assign(target, { [key]: {} });
        deepMerge(target[key], source[key]);
      } else {
        Object.assign(target, { [key]: source[key] });
      }
    }
  }

  return deepMerge(target, ...sources);
}

export const foldLeft = <A, B>(xs: Array<A>, zero: B) =>  (f: (b: B, a: A) => B): B => {
  const len = xs.length;
  if (len === 0) return zero;
  else {
    const head = xs[0];
    const tails = xs.slice(1);
    return foldLeft(tails, f(zero, head))(f);
  }
}
